import {
    getDiscountDetailById,
    deleteDiscountsByIds,
    getAllDiscount,
    storeAllDiscount,
    createDiscount,
    updateDiscount
} from "../api/actions/DiscountActions";
import {
    DISCOUNT_CREATE_EDIT_FORM_LOADING,
    DISCOUNT_CREATE_EDIT_FORM_DONE,
    DISCOUNT_CREATE_EDIT_FORM_ERROR,
    DISCOUNT_VIEW_BAR_SHOW,
    DISCOUNT_VIEW_BAR_LOADING,
    DISCOUNT_VIEW_BAR_DONE,
    DISCOUNT_VIEW_BAR_ERROR,
    DISCOUNT_CREATE_EDIT_FORM_CREATE,
    SET_SELECTED_DISCOUNTS,
    UPDATE_DISCOUNT_STATUS
} from "./actions/DiscountActions";
import {
    getDiscountsByTagId_Event,
    enableTagDiscountEdit_Event,
    deleteDiscountsFromSelectedTags_Event,
    insertDiscountsToSelectedTags_Event
} from "./TagDiscountEditorEvents";
import { $serializeForm } from "../main";
import store from "../redux/Store";
import { dispatchCustomEvent } from "../event/EventRouter";
import {
    dispatchDisableTagDiscountEdit_Event,
    updateDiscountsByTagId_Event,
    selectAllTags_Event,
    deselectTags_Event,
    deleteAllDiscountsFromSelectedTags_Event
} from "./TagDiscountEditorEvents";

export const deleteSelectedDiscountEvent = (selected) => {
    return async (dispatch, state) => {
        var ids = Object.keys(selected);
        if (Array.isArray(ids) && ids.length > 0) {
            deleteDiscountsByIds(ids)
                .then(response => {
                    if (typeof state.discounts != 'object') {
                        state.discounts = {};
                    }
                    //console.log('deleteSelectedDiscountEvent', response.content);
                    let ids = response.content;
                    Object.keys(ids).forEach(id => {
                        state.discounts[id] = {
                            [ids[id] > 0 ? 'deleted' : 'error']: true,
                            data: null
                        };
                    });
                    //console.log('deleteSelectedDiscountEvent.state', state.discounts);
                    dispatch(UPDATE_DISCOUNT_STATUS(state.discounts));
                })
                .catch((error) => {
                    console.log('deleteSelectedDiscountEvent', error);
                });
        }
    };
};
export const setSelectedDiscountEvent = (selected, list) => {
    return async (dispatch) => {
        dispatch(SET_SELECTED_DISCOUNTS(selected));
        list && list.setChecked(selected);
    };
};
export const deselectAllDiscountEvent = (selected, list) => {
    return async (dispatch) => {
        dispatch(SET_SELECTED_DISCOUNTS(selected));
        list && list.setChecked(selected);
    };
};
export const cancelDiscountEvent = (e) => {
    return async (dispatch) => {
        dispatch(DISCOUNT_CREATE_EDIT_FORM_CREATE());
    };
};
export const createDiscountFormEvent = (e) => {
    return async (dispatch) => {
        dispatch(DISCOUNT_CREATE_EDIT_FORM_CREATE());
    };
};
export const editDiscountEvent = (e, id) => {
    return async (dispatch) => {
        dispatch(DISCOUNT_CREATE_EDIT_FORM_LOADING);
        getDiscountDetailById(id)
            .then((result) => {
                dispatch(DISCOUNT_CREATE_EDIT_FORM_DONE(result.content));
            }).catch((error) => {
                dispatch(DISCOUNT_CREATE_EDIT_FORM_ERROR(error));
            });
    };
};
export const fetchAllDiscountsEvent = (force) => {

    let discounts = store.getState().base.discounts;

    if (force || !(Array.isArray(discounts) && discounts.length > 0)) {
        getAllDiscount()
            .then((result) => store.dispatch(storeAllDiscount(result.content)))
            .catch((error) => {
                console.log("Custom Error:", error, error.error);
            });
    }
};
export const getAllDiscountsEvent = (e, id) => {
    return async (dispatch) => {
        dispatch(DISCOUNT_CREATE_EDIT_FORM_LOADING);
        getDiscountDetailById(id)
            .then((result) => {
                dispatch(DISCOUNT_CREATE_EDIT_FORM_DONE(result.content));
            }).catch((error) => {
                dispatch(DISCOUNT_CREATE_EDIT_FORM_ERROR(error));
            });
    };
};
export const saveDiscountEvent = (form) => {
    return async (dispatch, state) => {

        const [encoded, json] = $serializeForm(form.current);
        console.log('saveDiscountEvent', json)

        if (json.id) {
            console.log('update ', json)
            updateDiscount(json)
                .then((result) => {
                    console.log('createDiscountEvent', result.content);
                }).catch((error) => {
                    console.log('createDiscountEvent', error);
                });
        } else {
            console.log('create', json)
            createDiscount(json)
                .then((result) => {
                    console.log('createDiscountEvent', result.content);
                }).catch((error) => {
                    console.log('createDiscountEvent', error);
                });

        }
    }
};

export const viewDiscountEvent = (e, id) => {
    return async (dispatch, state) => {

        if (typeof state.discounts != 'object') {
            state.discounts = {};
        }

        var discount = state.discounts[id];

        if (discount && discount.visibility) {
            discount.visibility = !discount.visibility;
            dispatch(DISCOUNT_VIEW_BAR_SHOW(state.discounts));
            return;
        }

        state.discounts[id] = {
            visibility: true,
            data: null,
            state: "LOADING"
        };

        dispatch(DISCOUNT_VIEW_BAR_LOADING(state.discounts));

        getDiscountDetailById(id)
            .then((result) => {
                console.log();
                if (result.content && result.content.id > 0) {
                    state.discounts[id] = {
                        visibility: true,
                        data: result.content,
                        state: "DONE"
                    };
                    dispatch(DISCOUNT_VIEW_BAR_DONE(state.discounts));
                }

            }).catch((error) => {
                state.discounts[id] = {
                    visibility: false,
                    data: error,
                    state: "ERROR",
                    error: true
                };
                dispatch(DISCOUNT_VIEW_BAR_ERROR(state.discounts));
            });
        console.log('viewDiscountEvent', state);
    };
};
export const getDiscountDetailByIdEvent = (e, id) => {
    return async (dispatch) => {

        dispatch({ status: "DONE", meta: { title: 'new', button: 'create', type: 'CREATE' }, payload: null });

    };

};
export const UPDATE_TAG_DISCOUNT_BY_TAG_ID = (payload) => ({
    class: 'custom_event',
    event: {
        type: 'default',
        name: 'fetch_all_discounts_by_tag_id_enable_edit_update_redux_Store',
        call: updateDiscountsByTagId_Event,
        payload: payload
    }
});
export const ENABLE_TAG_DISCOUNT_EDIT = (payload) => ({
    class: 'custom_event',
    event: {
        type: 'default',
        name: 'fetch_all_discounts_by_tag_id_enable_edit_update_redux_Store',
        call: enableTagDiscountEdit_Event,
        payload: payload
    }
});
export const DISABLE_TAG_DISCOUNT_EDIT = (payload) => ({
    class: 'custom_event',
    event: {
        type: 'default',
        name: 'disable_tag_discount_edit_event_update_redux_Store',
        call: dispatchDisableTagDiscountEdit_Event,
        payload: payload
    }
});
export const GET_DISCOUNTS_BY_TAG_ID = (payload) => ({
    class: 'custom_event',
    event: {
        type: 'default',
        name: 'fetch_all_discounts_by_tag_id_update_redux_Store',
        call: getDiscountsByTagId_Event,
        payload: payload
    }
});
export const DELETE_DISCOUNTS_BY_TAG_ID = (payload) => ({
    class: 'custom_event',
    event: {
        type: 'default',
        name: 'delete_selected_discounts_by_tag_ids_update_redux_Store',
        call: deleteDiscountsFromSelectedTags_Event,
        payload: payload
    }
});
export const INSERT_DISCOUNTS_BY_TAG_ID = (payload) => ({
    class: 'custom_event',
    event: {
        type: 'default',
        name: 'insert_selected_discounts_by_tag_ids_update_redux_Store',
        call: insertDiscountsToSelectedTags_Event,
        payload: payload
    }
});
export const SELECT_ALL_TAGS = (payload) => ({
    class: 'custom_event',
    event: {
        type: 'default',
        name: 'select_all_tags_in_discount_editor',
        call: selectAllTags_Event,
        payload: payload
    }
});
export const DESELECT_ALL_TAGS = (payload) => ({
    class: 'custom_event',
    event: {
        type: 'default',
        name: 'deselect_all_tags_in_discount_editor',
        call: deselectTags_Event,
        payload: payload
    }
});
export const DELETE_ALL_DISCOUNTS_FROM_SELECTED_TAGS = (payload) => ({
    class: 'custom_event',
    event: {
        type: 'default',
        name: 'delete_all_discounts_from_selected_tags',
        call: deleteAllDiscountsFromSelectedTags_Event,
        payload: payload
    }
});

export const dispatch_getDiscountsByTagIdEvent = (payload) => dispatchCustomEvent(GET_DISCOUNTS_BY_TAG_ID(payload));
export const dispatch_enableTagDiscountEditEvent = (payload) => dispatchCustomEvent(ENABLE_TAG_DISCOUNT_EDIT(payload));
export const dispatch_disableTagDiscountEditEvent = (payload) => dispatchCustomEvent(DISABLE_TAG_DISCOUNT_EDIT(payload));
export const dispatch_updateDiscountsByTagIdEvent = (payload) => dispatchCustomEvent(UPDATE_TAG_DISCOUNT_BY_TAG_ID(payload));
export const dispatch_deleteDiscountsFromTagsEvent = (payload) => dispatchCustomEvent(DELETE_DISCOUNTS_BY_TAG_ID(payload));
export const dispatch_insertDiscountsToTagsEvent = (payload) => dispatchCustomEvent(INSERT_DISCOUNTS_BY_TAG_ID(payload));
export const dispatch_selectAllTagsEvent = (payload) => dispatchCustomEvent(SELECT_ALL_TAGS(payload));
export const dispatch_deselectAllTagsEvent = (payload) => dispatchCustomEvent(DESELECT_ALL_TAGS(payload));
export const dispatch_deleteAllDiscountsFromSelectedTagsEvent = (payload) => dispatchCustomEvent(DELETE_ALL_DISCOUNTS_FROM_SELECTED_TAGS(payload));